import React from 'react';

import { CommonPropTypes } from '../Icons.types';

const Bookmaker: React.FC<CommonPropTypes> = ({ className, onClick }) => {
  return (
    <svg
      viewBox='0 0 16 20'
      fill='none'
      onClick={onClick}
      className={className}
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M2 20C1.45 20 0.979333 19.8043 0.588 19.413C0.196666 19.0217 0.000666667 18.5507 0 18V2C0 1.45 0.196 0.979333 0.588 0.588C0.98 0.196667 1.45067 0.000666667 2 0H14C14.55 0 15.021 0.196 15.413 0.588C15.805 0.98 16.0007 1.45067 16 2V18C16 18.55 15.8043 19.021 15.413 19.413C15.0217 19.805 14.5507 20.0007 14 20H2ZM2 18H14V2H12V9L9.5 7.5L7 9V2H2V18Z'
        fill='currentColor'
      />
    </svg>
  );
};

export default Bookmaker;
